import axios from "axios";
import { API } from "./client";

/**
 * User assigns a pending email to one or more projects.
 * Re-runs the full save pipeline and auto-learns the sender's email.
 */
export async function resolvePending(pendingEmailId, projectIds) {
  const selected = Array.isArray(projectIds) ? projectIds : [projectIds];
  const res = await axios.post(`${API}/email-routing/resolve-pending`, {
    pending_email_id: pendingEmailId,
    project_ids: selected.filter(Boolean),
  });
  return res.data;
}

/**
 * User marks the pending email as not belonging to any project.
 */
export async function dismissPending(pendingEmailId) {
  const res = await axios.post(`${API}/email-routing/dismiss-pending`, {
    pending_email_id: pendingEmailId,
  });
  return res.data;
}

/** Returns { auto_route_threshold, pending_threshold } for the current user. */
export async function getRouterThresholds() {
  const res = await axios.get(`${API}/email-routing/thresholds`);
  return res.data;
}

/** Saves updated thresholds { auto_route_threshold, pending_threshold }. */
export async function updateRouterThresholds(payload) {
  const res = await axios.patch(`${API}/email-routing/thresholds`, payload);
  return res.data;
}


export async function getRoutingAudit(params = {}) {
  const res = await axios.get(`${API}/email-routing/audit`, { params });
  return res.data;
}

export async function getRoutingMetrics() {
  const res = await axios.get(`${API}/email-routing/audit/metrics`);
  return res.data;
}

export async function getRoutingAuditDetail(intakeId) {
  const res = await axios.get(`${API}/email-routing/audit/${encodeURIComponent(intakeId)}`);
  return res.data;
}

export async function replayRoutingAudit(intakeId) {
  const res = await axios.post(`${API}/email-routing/audit/${encodeURIComponent(intakeId)}/replay`);
  return res.data;
}